import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import InvitationsTable from '@features/admin/invitations/components/InvitationsTable';
import SendInvitationModal from '@features/admin/invitations/components/SendInvitationModal';
import InviteScopeSelect, { ActiveScope } from '@features/admin/invitations/components/InviteScopeSelect';
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useEntityContext } from '@features/entity/hooks/usePermissions';
import { getApiScopeFromValue } from '@features/invitations/utils/getScopeFromParam';
import { SentInvitationTarget } from '@features/invitations/types/sendInvitationModalProps';

const NationInvitesPage: React.FC = () => {
  const { nationId } = useParams<{ nationId: string }>();
  const [showCreate, setShowCreate] = useState(false);
  const sid = Number(nationId);

  const { context } = useEntityContext();
  const [active, setActive] = useState<ActiveScope>({ scope: 'NATION', scopeRefId: sid });
  const [reloadSignal, setReloadSignal] = useState(0);

  const handleSent = (target: SentInvitationTarget) => {
    if (
      getApiScopeFromValue(target.scope) === getApiScopeFromValue(active.scope) &&
      Number(target.scopeRefId) === Number(active.scopeRefId)
    ) {
      setReloadSignal((k) => k + 1);
    }
  };

  const scopeSelector = sid > 0 ? (
    <InviteScopeSelect
      ownScope="N"
      ownScopeRefId={sid}
      ownLabel="This Nation"
      childPluralLabel="districts"
      onChange={setActive}
      fullWidth
    />
  ) : null;

  return (
    <Container fluid className="py-4">
      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4">
        <div className="ntcog-page-title-block mb-0">
          <h1 className="ntcog-page-heading mb-1">Invitations</h1>
          <p className="text-muted mb-0">Manage invitations for this nation and its districts</p>
        </div>
        {sid > 0 && (
          <RequirePermission mode="section" action={ACTION_CODES.SEND_INVITE_NATION} scopeType="NATION" scopeId={sid}>
            <Button variant="primary" onClick={() => setShowCreate(true)}>
              <i className="bi bi-send me-2" aria-hidden="true"></i>
              Invite User
            </Button>
          </RequirePermission>
        )}
      </div>

      <InvitationsTable
        scope={active.scope}
        scopeRefId={active.scopeRefId}
        showPagination={true}
        leadingControl={scopeSelector}
        reloadSignal={reloadSignal}
      />

      <SendInvitationModal
        show={showCreate}
        onHide={() => setShowCreate(false)}
        scope="N"
        scopeRefId={sid > 0 ? sid : undefined}
        scopeName={context?.scopeName}
        onSent={handleSent}
      />
    </Container>
  );
};

export default NationInvitesPage;
